<script>
  export default {
    props: {
      customClass: {
        type: String,
        default: 'fill-primary',
      },
      disableHover: {
        type: Boolean,
        default: false,
      },
    },
  }
</script>

<template>
  <svg
    :class="[customClass, { 'no-hover': disableHover }]"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M18.8293 12.9578L29.5334 14.0326C29.8604 14.0654 30.0987 13.7316 29.9595 13.4358L27.1092 7.38202C27.0512 7.25884 26.9368 7.17107 26.8022 7.14652L15.0407 5L18.4849 12.71C18.5465 12.848 18.678 12.9426 18.8293 12.9578ZM11.1707 12.9578L0.466568 14.0326C0.139558 14.0654 -0.0987262 13.7316 0.0405875 13.4358L2.89083 7.38207C2.94882 7.25889 3.06319 7.17112 3.19779 7.14657L14.9593 5.00005L11.515 12.7101C11.4534 12.848 11.322 12.9426 11.1707 12.9578ZM12.3935 13.7172L14.1692 9.43219C14.3933 8.89148 14.5766 8.92753 14.5767 9.51232V22.899L14.5765 25C14.3108 25.0006 14.0452 24.9735 13.7837 24.9189L3.09109 22.6841C2.89918 22.6439 2.76011 22.4781 2.75501 22.2833L2.57031 15.1991C2.56447 14.977 2.73359 14.7886 2.95643 14.7692L12.0391 13.9761C12.1966 13.9624 12.3333 13.8625 12.3935 13.7172ZM8.9118 22.001L12.9258 22.6434V19.9104H8.9118V22.001ZM17.9609 13.9762L27.0436 14.7692C27.2664 14.7886 27.4356 14.9769 27.4298 15.1991L27.2451 22.2832C27.24 22.478 27.1009 22.6439 26.909 22.684L16.2164 24.9188C15.9549 24.9735 15.6892 25.0006 15.4235 24.9999L15.4233 22.8989V9.51231C15.4233 8.92752 15.6067 8.89148 15.8308 9.43223L17.6065 13.7173C17.6667 13.8626 17.8034 13.9624 17.9609 13.9762ZM23.3057 18.5531L22.8041 18.5669L22.794 21.704C22.7935 21.8422 22.6522 21.9744 22.4766 21.9994L21.6544 22.1169C21.4667 22.1438 21.313 22.0481 21.3133 21.903L21.321 18.6078L20.7472 18.6236C20.4682 18.6313 20.2917 18.409 20.4337 18.225L21.7983 16.4582C21.9275 16.2907 22.2448 16.3062 22.3694 16.4826L23.5672 18.1789C23.6807 18.3398 23.5371 18.5467 23.3057 18.5531Z"/>
  </svg>
</template>
